export default __webpack_public_path__ + "static/media/reno-heading-picture.45667383.png";